import { ChangeEvent } from 'react';
import memoizeOne from 'memoize-one';

export const guardPhoneOnChange = memoizeOne(
	(onChange: (e: ChangeEvent<HTMLInputElement>) => void) =>
		(e: ChangeEvent<HTMLInputElement>) => {
			const filtered = e.target.value.replace(/[^\d+\s()]/g, '');
			e.target.value = filtered.trim();
			onChange(e);
		}
);
